import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const EventRegistrations = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [event, setEvent] = useState(null);
  const [registrations, setRegistrations] = useState([]);

  useEffect(() => {
    if (!id) return;

    // Load events created locally (see CreateEvent.js)
    let events = [];
    try {
      const raw = localStorage.getItem('eventfork_events');
      events = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(events)) {
        events = [];
      }
    } catch {
      events = [];
    }

    const numericId = Number(id);
    const found = events.find((e) => String(e.id) === String(id) || e.id === numericId);
    if (found) {
      setEvent(found);
    } else {
      setEvent({ id, name: `Event ${id}` });
    }

    // Load or create dummy registrations per event from localStorage
    let allRegs = {};
    try {
      const rawRegs = localStorage.getItem('eventfork_registrations');
      allRegs = rawRegs ? JSON.parse(rawRegs) : {};
    } catch {
      allRegs = {};
    }

    let eventRegs = Array.isArray(allRegs[id]) ? allRegs[id] : null;

    if (!eventRegs) {
      // Generate a dummy registration list (purely mock data)
      const count = Math.floor(Math.random() * 50) + 1; // 1 - 50
      const ticketTypes = ['Early Bird', 'Regular', 'VIP'];
      eventRegs = Array.from({ length: count }, (_, index) => ({
        id: index + 1,
        name: `Attendee ${index + 1}`,
        email: `attendee${index + 1}@example.com`,
        phone: `+91-98${(10000000 + index).toString().slice(0, 7)}`,
        ticketType: ticketTypes[index % ticketTypes.length],
        status: 'pending', // 'pending' | 'approved' | 'rejected'
      }));

      allRegs[id] = eventRegs;
      try {
        localStorage.setItem('eventfork_registrations', JSON.stringify(allRegs));
      } catch {
        // ignore write errors in mock mode
      }
    }

    setRegistrations(eventRegs);
  }, [id]);

  const updateRegistrations = (nextRegs) => {
    setRegistrations(nextRegs);
    try {
      const rawRegs = localStorage.getItem('eventfork_registrations');
      const allRegs = rawRegs ? JSON.parse(rawRegs) : {};
      allRegs[id] = nextRegs;
      localStorage.setItem('eventfork_registrations', JSON.stringify(allRegs));
    } catch {
      // ignore persistence errors in mock mode
    }
  };

  const handleChangeStatus = (regId, status) => {
    const next = registrations.map((r) =>
      r.id === regId ? { ...r, status } : r
    );
    updateRegistrations(next);
  };

  const count = registrations.length;

  return (
    <div className="event-registrations-page" style={{ padding: '2rem' }}>
      <button
        className="btn btn-secondary"
        type="button"
        onClick={() => navigate(-1)}
        style={{ marginBottom: '1rem' }}
      >
        Back
      </button>

      <h1 className="page-title">
        <i className="fas fa-users" /> Registrations
        {event ? ` - ${event.name}` : ''}
      </h1>

      <div style={{ marginTop: '1.5rem' }}>
        <h2>Total Registrations: {count}</h2>
        {count === 0 && (
          <p style={{ marginTop: '0.75rem', color: '#666' }}>
            No registrations yet for this event (dummy data).
          </p>
        )}
      </div>

      {count > 0 && (
        <div style={{ marginTop: '2rem' }}>
          <h3>Registrants (dummy list)</h3>
          <div
            style={{
              marginTop: '0.75rem',
              border: '1px solid #ddd',
              borderRadius: 4,
              maxWidth: 720,
            }}
          >
            <div
              style={{
                display: 'flex',
                padding: '8px 12px',
                fontWeight: 600,
                background: '#f7f7f7',
              }}
            >
              <div style={{ width: 50 }}>#</div>
              <div style={{ flex: 2 }}>Name</div>
              <div style={{ flex: 2 }}>Number</div>
              <div style={{ flex: 3 }}>Email</div>
              <div style={{ flex: 2 }}>Ticket Type</div>
              <div style={{ flex: 2 }}>Status</div>
              <div style={{ flex: 3 }}>Actions</div>
            </div>
            {registrations.slice(0, 20).map((r, index) => (
              <div
                key={r.id || index}
                style={{
                  display: 'flex',
                  padding: '8px 12px',
                  borderTop: '1px solid #eee',
                }}
              >
                <div style={{ width: 50 }}>{index + 1}</div>
                <div style={{ flex: 2 }}>{r.name}</div>
                <div style={{ flex: 2 }}>{r.phone}</div>
                <div style={{ flex: 3 }}>{r.email}</div>
                <div style={{ flex: 2 }}>{r.ticketType}</div>
                <div style={{ flex: 2, textTransform: 'capitalize' }}>{r.status}</div>
                <div style={{ flex: 3, display: 'flex', gap: 8 }}>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => handleChangeStatus(r.id, 'approved')}
                    disabled={r.status === 'approved'}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => handleChangeStatus(r.id, 'rejected')}
                    disabled={r.status === 'rejected'}
                  >
                    Reject
                  </button>
                </div>
              </div>
            ))}
            {count > 20 && (
              <div style={{ padding: '8px 12px', fontSize: '0.85rem', color: '#666' }}>
                Showing first 20 of {count} registrations (dummy data).
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EventRegistrations;
